import { t } from '@lumen/platform';

/** Lumen logo: a rounded square with a rising light beam. Our own mark, not derived from any other brand. */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-label={t('Lumen')} role="img" className="lm-logo">
      <rect x="2" y="2" width="28" height="28" rx="7" fill="currentColor" />
      <path d="M11 8v13.5c0 1.4 1.1 2.5 2.5 2.5H22" stroke="var(--lm-color-bg-default)" strokeWidth="3.2" strokeLinecap="round" fill="none" />
      <circle cx="21.5" cy="10.5" r="2.6" fill="var(--lm-color-bg-default)" />
    </svg>
  );
}
